import { TextConstants } from "./TextConstants";

const DriversConstants = {
    DRIVERS_CONSTANTS: {
        CONSIGNMENTS_DATA: {
            TABLE_WRAPPER_DATA: {
                title: "Drivers",
                HeaderData: [
                    {
                        field: 'id',
                        headerName: 'Id',
                        hide: true
                    },
                    {
                        field: 'driverId',
                        headerName: 'Driver ID',
                        width: 150,
                    },
                    {
                        field: 'driverName',
                        headerName: 'Driver Name',
                        width: 180,
                    },
                    {
                        field: 'vehicle',
                        headerName: 'Vehicle',
                        width: 150,
                        filter: true,
                        filterObj: {
                            type: "autocomplete",
                            fieldKey: "vehicle",
                            fieldName: "vehicle",
                            fieldFullName: "vehicle",
                            multiple: true,
                            key: `autoComplete-vehicle`,
                            label: "Vehicle",
                            items: []
                        }
                    },
                    {
                        field: 'vendor',
                        headerName: 'Vendor',
                        width: 180,
                        filter: true,
                        filterObj: {
                            type: "autocomplete",
                            fieldKey: "vendor",
                            fieldName: "vendor",
                            fieldFullName: "vendor",
                            multiple: true,
                            key: `autoComplete-vendor`,
                            label: "Vendor",
                            items: []
                        }
                    },
                    {
                        field: 'hubCode',
                        headerName: 'POS No',
                        width: 180,
                        filter: true,
                        filterObj: {
                            type: "autocomplete",
                            fieldKey: "hubCode",
                            fieldName: "hubCode",
                            fieldFullName: "hubCode",
                            multiple: true,
                            key: `autoComplete-hubCode`,
                            label: "Hub Code",
                            items: []
                        }
                    },
                    {
                        field: 'hubNames',
                        headerName: 'POS Name',
                        width: 180,
                        filter: true,
                        filterObj: {
                            type: "autocomplete",
                            fieldKey: "hubName",
                            fieldName: "hubName",
                            fieldFullName: "hubName",
                            multiple: true,
                            key: `autoComplete-hubName`,
                            label: "Hub Name",
                            items: []
                        }
                    },
                    {
                        field: 'status',
                        headerName: 'Status',
                        width: 180,
                        filter: true,
                        filterObj: {
                            type: "autocomplete",
                            fieldKey: "status",
                            fieldName: "status",
                            fieldFullName: "status",
                            multiple: true,
                            key: `autoComplete-status`,
                            label: "Status",
                            items: []
                        }
                    },
                    {
                        field: 'modes',
                        headerName: 'Assignment Mode',
                        width: 180,
                        filter: true,
                        filterObj: {
                            type: "autocomplete",
                            fieldKey: "modes",
                            fieldName: "modes",
                            fieldFullName: "modes",
                            multiple: true,
                            key: `autoComplete-modes`,
                            label: "Assignment Mode",
                            items: []
                        }
                    },
                    {
                        field: 'actions',
                        headerName: 'Actions',
                        width: 100,
                        hide: false
                    },
                ],
                headerButtons: [
                    {
                        name: "colsettings",
                        displayName: "Column Settings",
                        disabled: false,
                        childElements: [
                            {
                                name: "excel",
                                displayName: "Export Data",
                                disabled: false
                            }
                        ]
                    }
                ],
                loadMore: {
                    name: 'loadMore',
                    disabled: false,
                    pageSize: 20
                },
                defaultFiltersObj: {
                    hubCode: {
                        key: "hubCode",
                        value: [],
                    },
                    hubName: {
                        key: "hubNames",
                        value: [],
                    },
                    vehicle: {
                        key: "vehicle",
                        value: []
                    },
                    vendor: {
                        key: "vendor",
                        value: []
                    },
                    status: {
                        key: "status",
                        value: []
                    },
                    modes: {
                        key: "modes",
                        value: []
                    },
                    pageNumber: 0,
                },
                SEARCH_TYPES: [
                    {
                        name: "Driver ID",
                        value: "driverId"
                    },
                    {
                        name: "Driver Name",
                        value: "driverName"
                    }
                ],
                sortModel: {
                    field: "id",
                    direction: "asc"
                }
            },
            FILTER_CHIPS: [

                {
                    code: 'ACTIVE',
                    value: 'Active'
                },
                {
                    code: 'AVAILABLE',
                    value: 'Available'
                },
                {
                    code: 'ASSIGNED',
                    value: 'Assigned'
                },
                {
                    code: 'OUT_FOR_DELIVERY',
                    value: 'Out For Delivery'
                },
                {
                    code: 'AWAY',
                    value: 'Away'
                },
                {
                    code: 'BACK_TO_STORE',
                    value: 'Back To Store'
                },
                {
                    code: 'OFFLINE',
                    value: 'Offline'
                },
                {
                    code: "ALL",
                    value: "All"
                }
            ],
            DRIVER_STATUSES: {
                ACTIVE: {
                    color: "OCEAN_GREEN",
                    hintText: "",
                    value: "ACTIVE",
                  },
                  AVAILABLE: {
                    color: "SEA_GREEN",
                    hintText: "",
                    value: "AVAILABLE",
                  },
                  UNASSIGNED: {
                    color: "SEA_GREEN",
                    hintText: "",
                    value: "UNASSIGNED",
                  },
                  ASSIGNED: {
                    color: "ASSIGNED_LIGHT_BLUE",
                    hintText: "",
                    value: "ASSIGNED",
                  },
                  BACK_TO_STORE: {
                    color: "STORE_BROWN",
                    hintText: "",
                    value: "BACK_TO_STORE",
                  },
                  AWAY: {
                    color: "AMARANTH",
                    hintText: "",
                    value: "AWAY",
                  },
                  "OUT FOR DELIVERY": {
                    color: "DELIVARY_ORANGE",
                    hintText: "",
                    value: "OUT_FOR_DELIVERY",
                  },
                  OFFLINE: {
                    color: "PALE_GRAY",
                    hintText: "",
                    value: "OFFLINE",
                  },
            },
            STATUSES: {
                "ACTIVE": {
                    value: "ACTIVE",
                },
                "AVAILABLE": {
                    value: "AVAILABLE",
                },
                "UNASSIGNED": {
                    value: "UNASSIGNED",
                },
                "ASSIGNED": {
                    value: "ASSIGNED",
                },
                "BACK TO STORE": {
                    value: "BACK_TO_STORE",
                },
                "AWAY": {
                    value: "AWAY",
                },
                "OUT FOR DELIVERY": {
                    value: "OUT_FOR_DELIVERY",
                },
                "OFFLINE": {
                    value: "OFFLINE",
                },
            },
            DEFAULT_FILTER_CHIP: 'ACTIVE',
            TAB_VALUES: {
                DRIVER_PROFILE: 'User Profile',
                ACTIVITY_LOG: 'Activity Log',
            },
            ALL_FILTER_CHIP: "ALL",
            DRIVER_ASSIGNED_SUCCESS_MSG: "Driver Assigned successfully"
        },
        POS_TABLE:{
            POS_TABLE_COLUMNS : [
                { field: 'posNumber', label: 'POS Number', width: '30%' },
                { field: 'posName', label: 'POS Name', width: '70%' }
              ],
            POS_TABLE_SEARCH_CONFIG : {
                mode: "local" as "local",
                placeholder: TextConstants.SearchPOS,
                searchFields: ['posNumber', 'posName']
            }     
        },
        RESPONSE_CONSTANTS: {
            ERROR_CODES: {
                SESSION_TIMEOUT: "UM100",
                UNAUTHORISED: "UM101",
                CONCURRENT_CONSIGNMENT: "CWO15"
            }
        }
    },
}

export default DriversConstants;